import {Template} from '@mintdata-wsp/common/state/DataState';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {action} from 'mobx';

const sampleTemplates:Array<Template> = [
    {
        designId: 2780,
        devDesignId: 20074,
        templateUrl: 'calendar',
        publishedAppSubdomain: 'calendar-samples',
        categories: ['User Interface'],
        shortTitle: 'Calendar',
        shortDescription: 'A calendar application with various ways to view dates and times',
        description: `
            <p>This neatly designed application allows you to add tasks to the calendar, and then view all tasks that are due today, this week, or month.</p><p>Feel free to copy this design by clicking <strong>Use this template</strong> below. Customize it, if needed, and use in your application.</p>
            `,
        thumbnailUrl: [
            'https://assets.mintdata.com/website/mintdata-tv/showcase/calendar/1.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/calendar/2.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/calendar/3.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/calendar/4.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/calendar/5.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/calendar/6.jpg',
        ],
        thumbnailUrlWebP: [
            'https://assets.mintdata.com/website/mintdata-tv/showcase/calendar/1.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/calendar/2.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/calendar/3.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/calendar/4.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/calendar/5.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/calendar/6.webp',
        ],
    },
    {
        designId: 2795,
        devDesignId: 20078,
        templateUrl: 'task-manager',
        publishedAppSubdomain: 'task-manager-samples',
        categories: ['Full Applications'],
        shortTitle: 'Task Manager',
        shortDescription: 'Track your projects and tasks',
        description: `
            <p>Add projects and create tasks. Assign tasks to specific users and track their progress.</p><p>Feel free to copy this design by clicking <strong>Use this template</strong> below. Customize it, if needed, and use in your application.</p>
        `,
        thumbnailUrl: [
            'https://assets.mintdata.com/website/mintdata-tv/showcase/task-manager/1.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/task-manager/2.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/task-manager/3.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/task-manager/4.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/task-manager/5.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/task-manager/8.jpg',
        ],
        thumbnailUrlWebP: [
            'https://assets.mintdata.com/website/mintdata-tv/showcase/task-manager/1.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/task-manager/2.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/task-manager/3.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/task-manager/4.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/task-manager/5.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/task-manager/8.webp',
        ],
    },
    {
        templateUrl: 'email-composer',
        shortTitle: 'Email Composer',
        shortDescription: 'Send messages by email',
        designId: 2777,
        devDesignId: 20071,
        publishedAppSubdomain: 'email-composer-samples',
        thumbnailUrl: [
            'https://assets.mintdata.com/website/mintdata-tv/showcase/email-composer/1.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/email-composer/2.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/email-composer/3.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/email-composer/4.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/email-composer/5.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/email-composer/6.jpg',
        ],
        thumbnailUrlWebP: [
            'https://assets.mintdata.com/website/mintdata-tv/showcase/email-composer/1.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/email-composer/2.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/email-composer/3.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/email-composer/4.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/email-composer/5.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/email-composer/6.webp',
        ],
        categories: ['Work with Data'],
        description: `
            <p>Send messages by email. Use the built-in <span>MINTDATA™</span> flow editor to connect with an SMTP server and send an email message.</p>
        `
    },
    {
        templateUrl: 'fruity-invoices',
        description: `
            <p>Imagine you are a manager of a small fruit company. To create invoices based on orders for fruits and berries, you get to use this beautifully designed application that looks good and works well on any device. Add items from the stock and apply discounts for specific customers.</p><h2>1. Description <br></h2><p>Fruity Invoices is a great example of a MINTDATA no-code application that can be used by small companies to create invoices for their customers based on the purchase orders. With just a few clicks, we can make beautiful invoices that include our customer’s details, attractive images of fruits, quantity, and pricing information. </p><h2>2. Fluid interface <br></h2><p>Because of the responsive and adaptive design of Fruity Invoices, it looks good and works well on mobile, tablet, or desktop devices.</p><h2>3. Create your own app based on the template <br></h2><p>Start creating your own application based on the Fruity Invoices template. Customize the UI and data as needed. Thanks to the MINTDATA Multiplayer feature, you and your colleagues can work on the design at the same time, making the process fast and efficient.</p>
        `,
        shortTitle: 'Fruity Invoices',
        shortDescription: 'Manage orders for fruits and berries',
        designId: 2919,
        devDesignId: null,
        publishedAppSubdomain: 'fruity-invoices1-samples',
        thumbnailUrl: [
            'https://assets.mintdata.com/website/mintdata-tv/showcase/fruity-invoices/1.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/fruity-invoices/2.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/fruity-invoices/3.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/fruity-invoices/4.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/fruity-invoices/5.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/fruity-invoices/6.jpg',
        ],
        thumbnailUrlWebP: [
            'https://assets.mintdata.com/website/mintdata-tv/showcase/fruity-invoices/1.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/fruity-invoices/2.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/fruity-invoices/3.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/fruity-invoices/4.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/fruity-invoices/5.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/fruity-invoices/6.webp',
        ],
        categories: ['Full Applications']
    },
    {
        templateUrl: 'learn-frames',
        shortTitle: 'Learn Frames',
        shortDescription: 'Create and manipulate frames',
        designId: 2779,
        devDesignId: 20073,
        publishedAppSubdomain: 'learn-frames-samples',
        thumbnailUrl: [
            'https://assets.mintdata.com/website/mintdata-tv/showcase/learn-frames/1.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/learn-frames/2.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/learn-frames/3.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/learn-frames/4.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/learn-frames/5.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/learn-frames/6.jpg',
        ],
        thumbnailUrlWebP: [
            'https://assets.mintdata.com/website/mintdata-tv/showcase/learn-frames/1.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/learn-frames/2.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/learn-frames/3.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/learn-frames/4.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/learn-frames/5.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/learn-frames/6.webp',
        ],
        categories: ['Work with Data'],
        description: `
            <p><strong>Learn how to create and manipulate frames in practice. Create your own frames based on your data. Practice makes perfect!</strong></p><p>In this design, let's focus on our spreadsheet. The MINTDATA <a href="https://mintdata.com/" target="_blank">no code app builder</a> has the concept of frames, which are essentially nested spreadsheets. They can be easily created and modified.</p><h2>1. What is a frame?<br></h2><p>A frame has named columns and a set of rows. If a cell contains a <a href="https://mintdata.com/docs/reference/datatypes/frame/" target="_blank">frame</a> data type, it can be opened in a nested view. Let's see what frame types we have and what we can do with them.</p><h2>2. How to create a frame<br></h2><p>In our spreadsheet, we have two invoices that we can use to create frames. We can create frames in either of the two ways - the hard way and the easy one. The default, hard way means referencing the range (invoice) you want to convert to a frame in the FRAME function without any additional parameters. The frame is not updated automatically each time a new row is added to the invoice. The easy way implies using "true" as the third parameter in the FRAME function, whereby the frame is automatically updated each time a new row is added to the referenced invoice.</p><h2>3. What is a nested frame and how to create one<br></h2><p>A nested frame is a frame that contains other frames. We made a nested frame here by first converting both the invoices into frames and then putting these frames into another frame using the FRAME function.</p><h2>4. How to create a computed column<br></h2><p>We can add a computed column to our frame. A computed column is calculated based on other columns in the frame. For example, we've got an invoice with a column that has a subtotal in euros calculated based on the column in dollars. Here, we use the pipe operator to add a computed column to the frame. To get the subtotal in euros, first we need to multiply the subtotal in dollars by the exchange rate, and then wrap the expression into the ROUND function to display the result as a whole number.</p><h2>5. Group data by a column – just like Excel pivot tables<br></h2><p>Similar to Excel pivot tables, data in a frame can be grouped by a column. We use the GROUP_BY function to group the data by the company name. When we open the resulting nested frame, we see that the information is organized in a clear and logical way.</p><h2>6. How to filter data in a frame<br></h2><p>We can use the FILTER formula to search for the necessary information in the frame. In the first case, we'd like to find apples, and in the second – all the products under $2/kg.</p><h2>7. How to grab multiple relevant rows<br></h2><p>We can grab relevant information from a frame by using the GRAB function. Here, we've pulled out all fruits – there are only emojis now in the frame. In the next cell, we've pulled out the first fruit from our frame.</p><h2>8. How to glue two frames together<br></h2><p>One more thing we can do about frames is to glue them together. Here, we have two separate frames in our spreadsheet. We can easily glue them together by using the pipe symbol "|" between the cell references.</p><h2>9. How to augment a frame<br></h2><p>Our spreadsheet here contains two invoices grouped by company name. In a cell below, we use the AUG formula to add today's date to each row of data. And we use the FORMAT_DATE formula to make sure that the date is displayed correctly.</p><p>You've just learned how frames work. They are easy to create, modify, and manipulate on the MINTDATA platform. Explore the design yourself to find out more about frames!</p>
        `,
    },
    {
        templateUrl: 'photo-finder',
        shortTitle: 'Photo Finder',
        shortDescription: 'Search for photos',
        designId: 2791,
        devDesignId: 20069,
        publishedAppSubdomain: 'photo-finder-samples',
        thumbnailUrl: [
            'https://assets.mintdata.com/website/mintdata-tv/showcase/photo-finder/1.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/photo-finder/2.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/photo-finder/5.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/photo-finder/6.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/photo-finder/7.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/photo-finder/8.jpg',
        ],
        thumbnailUrlWebP: [
            'https://assets.mintdata.com/website/mintdata-tv/showcase/photo-finder/1.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/photo-finder/2.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/photo-finder/5.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/photo-finder/6.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/photo-finder/7.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/photo-finder/8.webp',
        ],
        categories: ['Full Applications'],
        description: `
            <p>Find and get inspired by beautiful, freely-usable images. Find out more about the photographer by clicking on their name on the photo.</p><h2>1. General look of the application <br></h2><p>The Photo Finder application has just one page. It’s simple and laconic. Typing in a random word will make an appropriate picture appear from unsplash.com. Photographers’ icons are clickable and point to their website, instagram or any page they’ve set up.</p><h2>2. The application logic <br></h2><p>The mechanics behind this application are simple – the API from unsplash.com sends you a link to one page with 20 pictures on it. You can change its number in the table if you wish. The GRAB_LISTS formula is used to pull out the URL, author, and tags from the stock base.</p><p>The Photo Finder is responsive and can be used on mobile, tablet, or desktop. The published application adjusts to your device nicely.</p>
        `,
    },
    {
        templateUrl: 'covid19',
        description: `
            <p>Feel free to copy this design by clicking <strong>Use this template</strong> below. Customize it, if needed, and use in your application.</p>
        `,
        shortTitle: 'COVID-19: 3D Visualization',
        shortDescription: 'A 3D time-lapse of the pandemic’s spread',
        designId: 2912,
        devDesignId: 20278,
        publishedAppSubdomain: 'covid19-samples',
        thumbnailUrl: [
            'https://assets.mintdata.com/website/mintdata-tv/showcase/covid42/1.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/covid42/2.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/covid42/3.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/covid42/4.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/covid42/5.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/covid42/6.jpg',
        ],
        thumbnailUrlWebP: [
            'https://assets.mintdata.com/website/mintdata-tv/showcase/covid42/1.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/covid42/2.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/covid42/3.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/covid42/4.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/covid42/5.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/covid42/6.webp',
        ],
        categories: ['User Interface'],
    },
    {
        templateUrl: 'report-viewer',
        description: `
            <p>Switch between different views in this application and explore how it is implemented in the application design.</p><p>Feel free to copy this design by clicking <strong>Use this template</strong> below. Customize it, if needed, and use in your application.</p>
        `,
        shortTitle: 'Report Viewer',
        shortDescription: 'View a financial report and switch between different views',
        designId: 2782,
        devDesignId: 20076,
        publishedAppSubdomain: 'report-viewer-samples',
        thumbnailUrl: [
            'https://assets.mintdata.com/website/mintdata-tv/showcase/report-viewer/1.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/report-viewer/2.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/report-viewer/3.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/report-viewer/4.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/report-viewer/5.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/report-viewer/6.jpg',
        ],
        thumbnailUrlWebP: [
            'https://assets.mintdata.com/website/mintdata-tv/showcase/report-viewer/1.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/report-viewer/2.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/report-viewer/3.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/report-viewer/4.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/report-viewer/5.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/report-viewer/6.webp',
        ],
        categories: ['User Interface'],
    },
    {
        templateUrl: 'store-radar',
        description: `
            <p><strong>Enter a ZIP code to find a wireless store location on the map.</strong></p><p>Store Radar is an easy-to-use no-code application that is based on a ZIP code API. Please take a look at Store Radar components below.</p><h2>1. Background image<br></h2><p>The background of the page is pale cyan. At the top of the page is a box component with the green linear gradient. We’ve placed the land image and some individual tree images to make the application look more appealing.</p><h2>2. Navigation bar and footer<br></h2><p>At the top of the page is a navigation bar with a company title, logo, and four tabs: Stores, Devices, Plans, and About. At the bottom of the page is a charcoal footer in the exact same style as the header. It matches the overall design nicely.</p><h2>3. Search Area<br></h2><p>Next, we have the search area box with two components: the Text Input component, where you enter a zip code, and a huge green Submit button. When we enter a ZIP code and then click the Submit button, the search result is displayed on the map below.</p><h2>4. Result Area<br></h2><p>As a part of the Map Holder, we have the text ‘Looking for devices’. The main element of this application is the map. There is a spinner effect over it, which looks like the loading process. When a location is found, it is displayed on the map.</p><h2>5. Logic behind the Store Radar<br></h2><p>To get location data from the GeoNames geographical database based on a ZIP code, we send a GET request to the API endpoint using the GET function. Next, we grab the location name, latitude and longitude and link the retrieved data with the Map component on the page.</p><p>That’s how easy it is to draw the UI and define the logic of the Store Radar application on the MINTDATA platform.</p>
        `,
        shortTitle: 'Store Radar',
        shortDescription: 'Find a wireless store location by ZIP code',
        designId: 2783,
        devDesignId: 20077,
        publishedAppSubdomain: 'store-radar-samples',
        thumbnailUrl: [
            'https://assets.mintdata.com/website/mintdata-tv/showcase/store-radar/1.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/store-radar/2.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/store-radar/3.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/store-radar/4.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/store-radar/5.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/store-radar/6.jpg',
        ],
        thumbnailUrlWebP: [
            'https://assets.mintdata.com/website/mintdata-tv/showcase/store-radar/1.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/store-radar/2.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/store-radar/3.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/store-radar/4.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/store-radar/5.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/store-radar/6.webp',
        ],
        categories: ['Work with Data'],
    },
    {
        templateUrl: 'taskninja',
        description: `
            <p>Create and keep track of personal tasks. Use frames to store the tasks with the UI driven by the spreadsheet.</p><p>Feel free to copy this design by clicking <strong>Use this template</strong> below. Customize it, if needed, and use in your application.</p>
        `,
        shortTitle: 'Task Ninja',
        shortDescription: 'Create and keep track of personal tasks',
        designId: 2890,
        devDesignId: 20197,
        publishedAppSubdomain: 'taskninja-samples',
        publishedAppDevice: 'mobile',
        thumbnailUrl: [
            'https://assets.mintdata.com/website/mintdata-tv/showcase/task-ninja/2.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/task-ninja/3.jpg',
        ],
        thumbnailUrlWebP: [
            'https://assets.mintdata.com/website/mintdata-tv/showcase/task-ninja/2.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/task-ninja/3.webp',
        ],
        categories: ['Work with Data'],
    },
    {
        templateUrl: 'use-api',
        description: `
            <p>Fetch a new email from an API each time the application is loaded.</p><p>Feel free to copy this design by clicking <strong>Use this template</strong> below. Customize it, if needed, and use in your application.</p>
        `,
        shortTitle: 'Use an API',
        shortDescription: 'Learn how to work with an API in practice.',
        designId: 2851,
        devDesignId: 20075,
        publishedAppSubdomain: 'use-api-samples',
        thumbnailUrl: [
            'https://assets.mintdata.com/website/mintdata-tv/showcase/use-api/1.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/use-api/2.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/use-api/3.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/use-api/4.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/use-api/8.jpg',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/use-api/7.jpg',
        ],
        thumbnailUrlWebP: [
            'https://assets.mintdata.com/website/mintdata-tv/showcase/use-api/1.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/use-api/2.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/use-api/3.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/use-api/4.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/use-api/8.webp',
            'https://assets.mintdata.com/website/mintdata-tv/showcase/use-api/7.webp',
        ],
        categories: ['Work with Data'],
    },
];

export class TemplatesController
{
    public init():void
    {
        if( controllers.user.isLoggedIn() )
            this.syncAllTemplates();
    }

    public syncAllTemplates():Promise<any>
    {
        return this.getAllTemplates()
            .then(action((allTemplates:Template[]) =>
            {
                rootState.data.templates = allTemplates;
            }));
    }

    public async getAllTemplates():Promise<Template[]>
    {
        if( rootState.userSession )
        {
            return Promise.resolve(sampleTemplates);
        }

        return null;
    }
}
